module.exports = __webpack_public_path__ + "img/Butterfly_00284.cc18cfd8.png";